/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { headerMiniCartItemSX, headerMiniCartclosebuttonSX } from '@/components/content/Header/styles/miniCart/item';
import { headerMiniCartItemsSX, headerMiniCartMenuSX } from '@/components/content/Header/styles/miniCart/menu';
import { headerMiniCartMoreItemsSX } from '@/components/content/Header/styles/miniCart/moreItems';
import { OrderItemTable } from '@/components/content/OrderItemTable';
import { useCart } from '@/data/Content/Cart';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { Box, Button, Divider, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC, useMemo } from 'react';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { ContentProvider } from '@/data/context/content';

export const HeaderMiniCartDropMenu: FC <{setOpen: (action: boolean) => void }|any> = ({setOpen}) => {
	//const router = useNextRouter();//commenting unused code
	//const { settings } = useSettings();

	const CartLabels = useLocalization('MiniCart');
	const RouteLabels = useLocalization('Routes');
	const { orderItems, data: order, canContinue, count, getCount, checkout, addRemoveFreeItemToCart } = useCart();
	
	//const locale = useMemo(() => router.locale ?? router.defaultLocale, [router]); //commenting unused code
	//const totalPrice = order?.grandTotal ?? '0.00';
	//const currency = order?.totalProductPriceCurrency ?? settings.defaultCurrency;
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const MAX_ROWS = isMobile ? 2 : 15;
	const { firstNRows, firstNRowsCount } = useMemo(() => {
		const firstNRows = orderItems?.slice(0, MAX_ROWS);
		const firstNRowsCount = getCount(firstNRows);
		return { firstNRows, firstNRowsCount };
	}, [MAX_ROWS, getCount, orderItems]);

	return (
		<Stack sx={headerMiniCartMenuSX} spacing={1} divider={<Divider />}>
			{firstNRows?.length > 0 ? (
				<Stack divider={<Divider />}>
					<Typography variant="h6" align="center" sx={headerMiniCartItemSX}>
						<Typography component='span'>
								{CartLabels.Title.t()}
                       			<CloseSharpIcon sx={headerMiniCartclosebuttonSX} onClick={() => setOpen(false)}/>
						</Typography>
					</Typography>
					<Stack sx={headerMiniCartItemsSX} >
						<ContentProvider value={{page:'minicart',addRemoveFreeItemToCart}}>
							<OrderItemTable orderItems={firstNRows} orderId={order?.orderId} variant="mini" />
						</ContentProvider>
						{count > firstNRowsCount ? (
							<Typography sx={headerMiniCartMoreItemsSX} align="right">
								{CartLabels.AndNMore.t({ count: count - firstNRowsCount })}
							</Typography>
						) : null}
					</Stack>
					<Typography variant="miniBody1" sx={headerMiniCartItemSX} align="center">
						<Box sx={{color:'#545454'}}>{CartLabels.CalculatedLaterMsg.t()}</Box>
					</Typography>
					<Stack direction="row" spacing={1} justifyContent="center" sx={headerMiniCartItemSX}>
						<Linkable
							href={RouteLabels.Cart.route.t()}
							type="button"
							variant="semiConversion"
							id="mini-cart-view-full-cart-button"
							data-testid="mini-cart-view-full-cart-button"
							sx={{lineHeight:'unset'}}
						>
							{CartLabels.Actions.Cart.t()}
						</Linkable>
						<Button
							variant="primaryConversion"
							disabled={!canContinue()}
							onClick={checkout}
							sx={{lineHeight:'unset'}}
							id="mini-cart-checkout-button"
							data-testid="mini-cart-checkout-button"
							color='success'
						>
							{CartLabels.Actions.CheckOut.t()}
						</Button>
					</Stack>
				</Stack>
			) : (
				<Stack spacing={1} alignItems="center" sx={headerMiniCartItemSX}>
					<Typography variant="body1" align="center">
						{CartLabels.Empty.t()}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};